import styled, { css } from 'styled-components';
import { getItemDimensions, getBackgroundColor, markerColors } from './helpers';
export const Wrapper = styled.div `
  display: flex;
  align-items: center;
  margin: -4px;
`;
export const Item = styled.div `
  ${({ isMarker, isDisabled }) => {
    const dimensions = getItemDimensions(!!isMarker);
    return css `
      width: ${dimensions.width};
      height: ${dimensions.height};
      cursor: ${!isMarker && !isDisabled ? 'pointer' : isDisabled ? 'not-allowed' : 'default'};
    `;
}}

  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 50%;

  svg {
    position: relative;
    z-index: 1;
    display: none;

    &:first-child {
      display: ${({ isSelected }) => (isSelected ? 'block' : 'none')};
    }

    &:not(:first-child) {
      display: ${({ isSelected }) => (isSelected ? 'none' : 'block')};
    }
  }

  &:before {
    content: '';
    display: block;
    border-radius: 50%;
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${getBackgroundColor};
    width: ${({ isMarker }) => getItemDimensions(!!isMarker).innerSize};
    height: ${({ isMarker }) => getItemDimensions(!!isMarker).innerSize};
    border: 1px solid ${({ isMarker, marker, theme }) => (isMarker ? markerColors[marker].border({ theme }) : 'transparent')};
    transition:
      width 0.2s,
      height 0.2s;
  }

  ${({ isDisabled, isSelected, marker, theme, isMarker }) => !isDisabled &&
    !isMarker &&
    css `
      &:hover {
        &:before {
          width: ${getItemDimensions(false).hoverSize};
          height: ${getItemDimensions(false).hoverSize};
          border: 1px solid ${markerColors[marker].border({ theme })};
        }

        svg {
          &:first-child {
            display: ${isSelected ? 'none' : 'block'};
          }
          &:not(:first-child) {
            display: ${isSelected ? 'block' : 'none'};
          }
        }
      }
    `}
`;
export const SelectedMarker = styled(Item).attrs(() => ({ isMarker: true })) ``;
